export default "__VITE_ASSET___3dl9bwF__"